import { createSlice } from '@reduxjs/toolkit';

import {
  MultipleLeadsCaseReducers,
  MultipleLeadsCaseSelectors,
  MultipleLeadsState
} from './types';

const initialState: MultipleLeadsState = {
  isLoading: false,
  isModalOpen: false,
  isSuccessModalOpen: false,
  relatedProperties: [],
  propertyId: 0,
  type: 'terrains'
};

const multipleLeads = createSlice<
  MultipleLeadsState,
  MultipleLeadsCaseReducers,
  'multipleLeads',
  MultipleLeadsCaseSelectors
>({
  name: 'multipleLeads',
  initialState,
  reducers: {
    cancelMultipleLeads: (state) => {
      state.isModalOpen = false;
      state.relatedProperties = [];
    },
    loadMultipleLeadsModal: (state, action) => {
      state.isLoading = true;
      state.propertyId = action.payload.propertyId;
      state.type = action.payload.type;
    },
    openMultipleLeadsModal: (state, action) => {
      state.isLoading = false;
      state.isModalOpen = true;
      state.relatedProperties = action.payload;
    },
    sendMultipleLeads: (state) => {
      state.isLoading = true;
    },
    openMultipleLeadsSuccessModal: (_state, action) => {
      return {
        ...initialState,
        isSuccessModalOpen: true,
        relatedProperties: action.payload
      };
    },
    closeMultipleLeadsSuccessModal: () => {
      return initialState;
    }
  }
});

export const {
  cancelMultipleLeads,
  closeMultipleLeadsSuccessModal,
  loadMultipleLeadsModal,
  openMultipleLeadsModal,
  openMultipleLeadsSuccessModal,
  sendMultipleLeads
} = multipleLeads.actions;

export default multipleLeads.reducer;
